import type { SVGProps } from 'react'

export const InsightsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.5 1H2.33333C1.8731 1 1.5 1.3731 1.5 1.83333V7.66667C1.5 8.1269 1.8731 8.5 2.33333 8.5H6.5C6.96024 8.5 7.33333 8.1269 7.33333 7.66667V1.83333C7.33333 1.3731 6.96024 1 6.5 1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6667 1H11.5C11.0398 1 10.6667 1.3731 10.6667 1.83333V4.33333C10.6667 4.79357 11.0398 5.16667 11.5 5.16667H15.6667C16.1269 5.16667 16.5 4.79357 16.5 4.33333V1.83333C16.5 1.3731 16.1269 1 15.6667 1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6667 8.5H11.5C11.0398 8.5 10.6667 8.8731 10.6667 9.33333V15.1667C10.6667 15.6269 11.0398 16 11.5 16H15.6667C16.1269 16 16.5 15.6269 16.5 15.1667V9.33333C16.5 8.8731 16.1269 8.5 15.6667 8.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 11.8333H2.33333C1.8731 11.8333 1.5 12.2064 1.5 12.6667V15.1667C1.5 15.6269 1.8731 16 2.33333 16H6.5C6.96024 16 7.33333 15.6269 7.33333 15.1667V12.6667C7.33333 12.2064 6.96024 11.8333 6.5 11.8333Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
